import { useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import { CreateSocialMediaApi } from "../../../services/apis/EventMangement/CreateEventApi";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { CreateSocialHandlesApi } from "../../../services/apis/Agency";
import BtnLoader from "../Loader/BtnLoader";
import Swal from "sweetalert2";
import facebookIcn from "../../../assets/images/SocialMedia/facebook.png";
import instagramIcn from "../../../assets/images/SocialMedia/instagram.png";
import LinkedinIcn from "../../../assets/images/SocialMedia/linkedin.png";
import TwitterIcn from "../../../assets/images/SocialMedia/twitter.png";
import SkypeIcn from "../../../assets/images/SocialMedia/skype.png";
import YoutubeIcn from "../../../assets/images/SocialMedia/youtube.png";
import WhatsAppIcn from "../../../assets/images/SocialMedia/whatsapp.png";
import WhatsAppBusinessIcn from "../../../assets/images/SocialMedia/whatsappbusiness.svg";

const SocialHandles = ({agencyId, setTabValue }) => {
    const [socialMedia, setSocialMedia] = useState({
        facebook: "",
        instagram: "",
        linkedin: "",
        twitter: "",
        skype:"",
        youtube: "",
        whatsapp:"",
        whatsapp_business:""
    });
    const [btnLoading,setBtnLoading]=useState("");
    const [errors, setErrors] = useState({});

    console.log("errors",errors)
    // Regular expression for URL validation
    const urlRegex = /^(https?:\/\/)?([\w.-]+)\.([a-z]{2,})(\/[\w.-]*)*\/?$/;

    // Handle input changes
    const handleChange = (e) => {
        const { name, value } = e.target;
        setSocialMedia((prev) => ({
            ...prev,
            [name]: value,
        }));
    };


    // Validate the entire from
    const validate = () => {
        const newErrors = {};
    
        const regexPatterns = {
            instagram: /^(https?:\/\/)?(www\.)?instagram\.com\/[A-Za-z0-9_.-]+\/?$/,
            facebook: /^(https?:\/\/)?(www\.)?facebook\.com\/[A-Za-z0-9_.-]+\/?$/,
            twitter: /^(https?:\/\/)?(www\.)?twitter\.com\/[A-Za-z0-9_]+\/?$/,
            linkedin: /^(https?:\/\/)?(www\.)?linkedin\.com\/in\/[A-Za-z0-9_.-]+\/?$/,
            skype: /^[a-zA-Z][a-zA-Z0-9_.-]{5,31}$/ // Skype username rules
        };
    
        // Validate each field using regex
        Object.keys(regexPatterns).forEach((field) => {
            if (socialMedia[field] && !regexPatterns[field].test(socialMedia[field])) {
                newErrors[field] = `Invalid ${field} format.`;
            }
        });
        // Validate WhatsApp numbers (should be only digits)
       
        if (socialMedia.whatsapp && !/^\d+$/.test(socialMedia.whatsapp)) {
            newErrors.whatsapp = "Invalid WhatsApp number.";
        }
        if (socialMedia.whatsapp_business && !/^\d+$/.test(socialMedia.whatsapp_business)) {
            newErrors.whatsapp_business = "Invalid WhatsApp Business number.";
        }
    
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };
    
    
    // Handle form submission
    const handleSubmit = async (e) => {
        e.preventDefault();
        if(validate()){
        try {
            const response = await CreateSocialHandlesApi(agencyId,socialMedia);
            if (response?.data?.success) {
                Swal.fire({
                  icon: "success",
                  title: "Agency",
                  text: response?.data?.message,
                });
                toast.success(response?.data?.message, {
                 position: 'top-center'
                });
                setSocialMedia({
                 facebook: "",
                 instagram: "",
                 linkedin: "",
                 twitter: "",
                 youtube: "",
                });
                setTabValue("Compliance-Verification");
            }
        } catch (error) {
            console.error("Error while submitting the form:", error);
            toast.error(error?.response?.data?.message);
        }finally{
            setBtnLoading(false)
        }
       }
        // Proceed with form submission or API call
    };

    const handlePhoneChange = (value, country) => {
        const phoneNum = value?.slice(2);
        const country_code = `${country.format.charAt(0)}${country?.dialCode}`;
        const phone = `${country_code}${phoneNum}`;
        console.log("country_code", country_code);
        setSocialMedia({
          ...socialMedia,
          phone: phone,
        });
      };
    
      const handleAlternatePhoneChange = (value, country) => {
        const phoneNum = value?.slice(2);
        const country_code = `${country.format.charAt(0)}${country?.dialCode}`;
        const phone = `${country_code}${phoneNum}`;
        console.log("country_code", country_code);
        setSocialMedia({
          ...socialMedia,
          alternate_phone: phone,
        });
      };

    return (
        <>
            <ToastContainer />
            <div className="container-fluid my-0">
                <form onSubmit={handleSubmit}>
                    <div className=" row">
                        <div className="mb-3 row">
                            <div className="col-md-6">
                                <label className="col-sm-6 col-form-label d-flex align-items-center gap-1">
                                  <img src={facebookIcn} alt="fb" height={20}/>  Facebook</label>
                                <input
                                    name="facebook"
                                    type="url"
                                    className="form-control"
                                    placeholder="Ex: http://domain.com/"
                                    value={socialMedia.facebook}
                                    onChange={handleChange}
                                    maxLength={120}
                                />
                                {errors.facebook && <small className="text-danger">{errors.facebook}</small>}
                            </div>

                            <div className="col-md-6">
                                <label className="col-sm-6 col-form-label d-flex align-items-center gap-1">
                                <img src={instagramIcn} alt="fb" height={20}/> Instagram</label>
                                <input
                                    name="instagram"
                                    type="url"
                                    className="form-control"
                                    placeholder="Ex: http://domain.com/"
                                    value={socialMedia.instagram}
                                    onChange={handleChange}
                                    maxLength={120}
                                />
                                {errors.instagram && <small className="text-danger">{errors.instagram}</small>}
                            </div>
                        </div>

                        <div className="mb-3 row">
                            <div className="col-md-6">
                                <label className="col-sm-6 col-form-label d-flex align-items-center gap-1">
                                <img src={LinkedinIcn} alt="fb" height={20}/>Linkedin</label>
                                <input
                                    name="linkedin"
                                    type="url"
                                    className="form-control"
                                    placeholder="Ex: http://domain.com/"
                                    value={socialMedia.linkedin}
                                    onChange={handleChange}
                                    maxLength={120}
                                />
                                {errors.linkedin && <small className="text-danger">{errors.linkedin}</small>}
                            </div>

                            <div className="col-md-6">
                                <label className="col-sm-6 col-form-label">
                                <img src={TwitterIcn} alt="fb" height={20}/>Twitter</label>
                                <input
                                    name="twitter"
                                    type="url"
                                    className="form-control"
                                    placeholder="Ex: http://domain.com/"
                                    value={socialMedia.twitter}
                                    onChange={handleChange}
                                    maxLength={120}
                                />
                                {errors.twitter && <small className="text-danger">{errors.twitter}</small>}
                            </div>
                        </div>

                        <div className="mb-3 row">
                            <div className="col-md-6">
                                <label className="col-sm-6 col-form-label">
                                <img src={SkypeIcn} alt="fb" height={20}/>Skype</label>
                                <input
                                    name="skype"
                                    type="url"
                                    className="form-control"
                                    placeholder="Ex: http://domain.com/"
                                    value={socialMedia.skype}
                                    onChange={handleChange}
                                    maxLength={120}
                                />
                                {errors.skype && <small className="text-danger">{errors.skype}</small>}
                            </div>

                            <div className="col-md-6">
                                <label className="col-sm-6 col-form-label">
                                <img src={YoutubeIcn} alt="fb" height={20}/> Youtube</label>
                                <input
                                    name="youtube"
                                    type="url"
                                    className="form-control"
                                    placeholder="Ex: http://domain.com/"
                                    value={socialMedia.youtube}
                                    onChange={handleChange}
                                    maxLength={120}
                                />
                                {errors.youtube && <small className="text-danger">{errors.youtube}</small>}
                            </div>
                        </div>

                        <div className="row">
                        <div className="col-md-6">
                             <label className="col-form-label">
                             <img src={WhatsAppIcn} alt="fb" height={20}/> WhatsApp Number <span className="asterisk">*</span>
                             </label>
                             <PhoneInput
                               className=""
                               inputClass="w-100"
                               country={"in"}
                               value={socialMedia?.whatsapp}
                               onChange={handlePhoneChange}
                             />
                             {errors.whatsapp && (
                               <small className="text-danger">{errors.whatsapp}</small>
                             )}
                           </div>
                           <div className="col-md-6">
                             <label className="col-form-label">
                             <img src={WhatsAppBusinessIcn} alt="fb" height={24}/> WhatsApp Business Number
                             </label>
                             <PhoneInput
                               className=""
                               inputClass="w-100"
                               country={"in"}
                               value={socialMedia?.whatsapp_business}
                               onChange={handleAlternatePhoneChange}
                             />
                             {errors.whatsapp_business && (
                               <small className="text-danger">
                                 {errors.whatsapp_business}
                               </small>
                             )}
                           </div>
                        </div>

                        <div className="d-flex justify-content-end gap-4 px-5 pt-4">
                            <div className="">
                              <button type="button" className="btn btn-outline-primary"
                                onClick={()=>setTabValue("Compliance-Verification")}>
                                Skip
                              </button>
                            </div>

                            <div className="">
                                <button type="submit" className="btn btn-primary">
                                   {btnLoading && <BtnLoader/>} Save and Continue
                                </button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </>
    );
};

export default SocialHandles;
